// extracted by mini-css-extract-plugin
export default {"groupsPage":"styles_groupsPage__4xYqq","groupsContent":"styles_groupsContent__EqFrl","sectionButton":"styles_sectionButton__ofNFS"};